import { AuthEmailPasswordSignInForm } from '../../../components';
import { useAuthEmailPasswordSignInForm } from './hooks';

import type { FC } from 'react';
import type { AuthEmailPasswordSignInFormWidgetProps } from './AuthEmailPasswordSignInForm.types';

const AuthEmailPasswordSignInFormWidget: FC<
  AuthEmailPasswordSignInFormWidgetProps
> = ({ widget }) => {
  const { isLoading, onSubmit } = useAuthEmailPasswordSignInForm(widget);

  const onResetPassword = () => {
    // TODO: read this from navigation registry.
    globalThis.location.href = '/account/reset-password';
  };

  return (
    <AuthEmailPasswordSignInForm
      data={widget.data!}
      isLoading={isLoading}
      onResetPassword={onResetPassword}
      onSubmit={onSubmit}
      config={widget.config}
    />
  );
};

AuthEmailPasswordSignInFormWidget.displayName =
  'AuthEmailPasswordSignInFormWidget';

export { AuthEmailPasswordSignInFormWidget };
